<template>
  <v-flex md12 class="pt-0">
    <material-card
      color="blue"
      title="Dados do Cliente"
      :text="user && user.customer_id ? user.customer_id : ''"
      class="pt-0"
    >
      <v-layout
        v-if="mode === 'edit'"
        align-center
        justify-end
        row
        fill-height
        class="px-3 pb-0"
      >
        <v-btn dark color="blue darken-5" @click="goToCustomerCare()">
          <v-icon left color="white">accessibility_new</v-icon>
          Ir para tela de atendimento
        </v-btn>
      </v-layout>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container py-0>
          <v-layout wrap>
            <v-flex xs12 sm12 md12 class="pb-0 pt-4">
              <h2 class="font-weight-bold title">Dados pessoais</h2>
            </v-flex>
            <v-flex xs12 md4>
              <v-autocomplete
                :items="person_type_items"
                item-text="text"
                item-value="value"
                label="Entidade*"
                v-model="user.person_type"
                :rules="[(v) => !!v || 'Por favor, selecione o tipo de pessoa']"
                required
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md4>
              <v-autocomplete
                :items="companies"
                label="Empresa*"
                v-model="user.company"
                :rules="[(v) => !!v || 'Por favor, informe a empresa!']"
                required
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                id="cpf"
                :label="user.person_type === 'pj' ? 'CNPJ*' : 'CPF*'"
                v-model="user.cpf"
                :mask="
                  user.person_type === 'pj'
                    ? '##.###.###/####-##'
                    : '###.###.###-##'
                "
                :rules="
                  user.person_type === 'pj'
                    ? [
                        (v) =>
                          (v && v.length == 14) || 'Preencha o CNPJ Completo',
                        (v) => this.validaCNPJ(v) === true || 'CNPJ inválido',
                      ]
                    : [
                        (v) =>
                          (v && v.length >= 11) || 'Preencha o CPF Completo',
                        (v) => this.validaCPF(v) === true || 'CPF inválido',
                      ]
                "
                required
                @change="buscaMember($event, 'cpf')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                v-model.lazy="user.email"
                label="E-mail*"
                name="email"
                type="email"
                required
                @change="buscaMember($event, 'email')"
                :rules="[
                  (v) => !!v || 'Por favor, informe o email',
                  (v) =>
                    /^(([^<>()\[\]\\.,;:\s@&quot;]+(\.[^<>()\[\]\\.,;:\s@&quot;]+)*)|(&quot;.+&quot;))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
                      v,
                    ) || 'E-mail precisa ser válido',
                ]"
                :readonly="mode == 'edit'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                v-model="user.name"
                name="name"
                label="Nome Completo*"
                required
                :rules="[(v) => !!v || 'Por favor, informe o nome!']"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md4>
              <v-text-field
                label="Telefone*"
                v-model="user.phone"
                :rules="[
                  (v) => !!v || 'Por favor, informe o eelefone!',
                  (v) =>
                    (v && v.length > 10) ||
                    'Ops. Parece que esse não é um número de telefone',
                ]"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                id="ID_document"
                v-model="user.ID_document"
                label="Documento"
                hint="Opcional"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-autocomplete
                :items="payment_type_items"
                item-text="text"
                item-value="value"
                label="Método de pagamento"
                v-model="user.payment_type"
                hint="Opcional"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 v-if="user.payment_type === 'credit_card'">
              <v-text-field
                id="card_default"
                v-model="user.card_default"
                label="Cartão Padrão"
                hint="Opcional"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                id="average_consumption"
                v-model.number="user.average_consumption"
                prefix="R$"
                label="Média de Consumo"
                mask="########"
                hint="Opcional"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                name="date_of_birth"
                v-model="user.date_of_birth"
                label="Data de Nascimento"
                return-masked-value
                mask="##/##/####"
                hint="Opcional"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-autocomplete
                :items="gender_items"
                item-text="text"
                item-value="value"
                label="Gênero"
                v-model="user.gender"
                hint="Opcional"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3>
              <v-autocomplete
                :items="marital_status"
                label="Estado Civil"
                v-model="user.marital_status"
                hint="Opcional"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 v-if="user.marital_status === 'Casado'">
              <v-autocomplete
                :items="marital_type"
                label="Regime de Bens"
                v-model.lazy="user.marital_type"
                hint="Opcional"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                id="profession"
                v-model="user.profession"
                label="Profissão"
                hint="Opcional"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12 class="py-0">
              <h2 class="font-weight-bold title">Endereço do Cliente</h2>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                id="postal_code"
                v-model="user.address.postal_code"
                label="CEP"
                required
                :rules="[(v) => !!v || 'Por favor, informe o CEP!']"
                @change="buscaCep($event)"
                mask="#####-###"
              >
                <template v-slot:append>
                  <v-progress-circular
                    v-if="loading_cep"
                    indeterminate
                    color="primary"
                    size="18"
                  ></v-progress-circular>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-autocomplete
                :items="states"
                item-text="name"
                item-value="initials"
                label="Estado"
                v-model="user.address.state"
                return-object
                :rules="[(v) => !!v || 'Por favor, selecione o seu Estado!']"
                required
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                id="city"
                v-model="user.address.city"
                label="Cidade"
                :rules="[(v) => !!v || 'Por favor, informe a Cidade!']"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                id="district"
                v-model="user.address.district"
                label="Bairro"
                :rules="[(v) => !!v || 'Por favor, informe o Bairro!']"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                id="address"
                v-model="user.address.address"
                label="Logradouro"
                :rules="[(v) => !!v || 'Por favor, informe o Logradouro!']"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                id="address_number"
                v-model="user.address.address_number"
                label="Número"
                :rules="[(v) => !!v || 'Por favor, informe o Número!']"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                id="address_complement"
                v-model="user.address.address_complement"
                label="Complemento"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm12 md12 class="py-0" v-if="mode === 'edit'">
              <h2 class="font-weight-bold title">Outros dados</h2>
            </v-flex>

            <v-flex xs12 md2 v-if="mode === 'edit'">
              <label><strong>Status:</strong></label>
              <p>{{ user.status | formatUserStatus }}</p>
            </v-flex>
            <v-flex xs12 md2 v-if="mode === 'edit'">
              <label><strong>Indicado por:</strong></label>
              <p>{{ user.promo_code ? user.promo_code : "Sem indicação" }}</p>
            </v-flex>

            <v-flex xs6 md2 v-if="mode === 'edit'">
              <v-btn color="blue" @click="showDocumentModal(user)" block>
                <v-icon class="mr-2" size="16">mdi-file</v-icon> Documentos
              </v-btn>
            </v-flex>

            <v-flex xs6 md2 v-if="mode === 'edit'">
              <v-btn color="blue" @click.prevent="openQualification()" block>
                <v-icon left dark>policy</v-icon>
                Qualificar
              </v-btn>
            </v-flex>

            <v-flex xs6 md2 v-if="mode === 'edit'">
              <v-btn
                color="primary"
                block
                @click="updateUserFunction()"
                :loading="loadingUpdateUser"
              >
                <v-icon left dark>mdi-plus</v-icon>
                Atualizar
              </v-btn>
            </v-flex>

            <v-layout
              v-else
              align-center
              justify-end
              row
              fill-height
              class="pa-0 pb-4 pr-4"
            >
              <v-btn
                color="primary"
                @click="createUser()"
                :loading="loadingCreateUser"
              >
                <v-icon left dark>mdi-plus</v-icon>
                Cadastrar
              </v-btn>
            </v-layout>
          </v-layout>
        </v-container>
      </v-form>
    </material-card>

    <cpnCustomerQualify :user="user" />

    <v-snackbar
      :color="snack.color"
      :bottom="snack.bottom"
      :top="snack.top"
      :left="snack.left"
      :right="snack.right"
      v-model="snack.snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snack.snackMessage }}</div>
      <v-icon size="16" @click="snack.snackbar = false">
        mdi-close-circle
      </v-icon>
    </v-snackbar>

    <DocumentModal ref="documentModal" />
  </v-flex>
</template>
<script>
import statesfile from "@/model/state";
import moment from "moment";
import { mask } from "vue-the-mask";
import { mapActions, mapGetters, mapMutations } from "vuex";
import firestore from "../../firebase/firestore";
import { eventBus } from "../../main";
import { getCEP } from "../../services/getCep";
import {
  getComplementaryData,
  storeCustomer,
  updateUser,
  validaCNPJ,
  validaCPF,
} from "../../services/users";
import { formatPhone, reversePhone } from "../../utils/utils";

import DocumentModal from "../../components/sales/kanban/DocumentModal.vue";
import CustomerQualify from "./CustomerQualify";

export default {
  components: {
    cpnCustomerQualify: CustomerQualify,
    DocumentModal,
  },
  data: function () {
    return {
      states: statesfile.estados,
      change: "",
      user: this.getInitialUser(),
      mode: "new",
      valid: false,
      snack: {
        color: null,
        top: true,
        bottom: false,
        left: false,
        right: false,
        snackMessage: "",
        snackbar: false,
      },
      marital_status: [
        "Solteiro",
        "Casado",
        "Separado",
        "Divorciado",
        "Viúva",
        "Viúvo",
      ],
      marital_type: [
        "Comunhão Universal de Bens",
        "Comunhão Parcial de Bens",
        "Separação Total de Bens",
        "Participação Final nos Aquestos",
      ],
      companies: [
        {
          text: "Elétron",
          value: "eletron",
        },
        {
          text: "Juntos",
          value: "juntos",
        },
      ],
      person_type_items: [
        { text: "Pessoa Física", value: "pf" },
        { text: "Pessoa Jurídica", value: "pj" },
      ],
      gender_items: [
        { text: "Masculino", value: "M" },
        { text: "Feminino", value: "F" },
      ],
      payment_type_items: [
        { text: "Boleto", value: "boleto" },
        { text: "Pix", value: "pix" },
        { text: "Cartão de Crédito", value: "credit_card" },
      ],
      loading_cep: false,
      loading: false,
      loadingCreateUser: false,
      loadingUpdateUser: false,
      phoneFormatted: "",
      dateOfBirthFormatted: "",
      maritalTypeFormatted: "",
    };
  },

  directives: { mask },

  async mounted() {
    if (this.$route.params.id) {
      await firestore
        .collection("users")
        .doc(this.$route.params.id)
        .get()
        .then((user) => {
          const actualUser = this.setUserData(user.data());
          this.setUser(actualUser);
          this.user = actualUser;
          this.mode = "edit";
        });
    }
  },

  computed: {
    ...mapGetters(["loggedUser"]),
  },

  watch: {
    "user.phone": {
      handler(newValue) {
        this.phoneFormatted = reversePhone(newValue);
      },
      immediate: true,
    },
    phoneFormatted(newValue) {
      this.user.phone = formatPhone(newValue, "+55");
    },

    "user.date_of_birth": {
      handler(newValue) {
        const birth = newValue || this.user.birthday || null;
        if (birth) {
          if (typeof birth === "string") {
            this.dateOfBirthFormatted = birth.replace(
              /^(\d{4})-(\d{2})-(\d{2}).*$/,
              "$3/$2/$1",
            );
          } else {
            if (birth.seconds) {
              this.dateOfBirthFormatted = moment(
                new Date(birth.seconds * 1000),
              ).format("DD/MM/YYYY");
            } else {
              const value = birth?.seconds?.toDate();
              this.dateOfBirthFormatted = moment(value)?.format("DD/MM/YYYY");
            }
          }
        } else {
          this.dateOfBirthFormatted = "";
        }
      },
      immediate: true,
    },
    dateOfBirthFormatted(newValue) {
      this.user.date_of_birth = newValue;
    },

    "user.marital_type": {
      handler(newValue) {
        if (!newValue) {
          this.maritalTypeFormatted = "";
        } else if (newValue === "Parcial de bens") {
          this.maritalTypeFormatted = "Comunhão Parcial de Bens";
        } else if (newValue === "Universal de bens") {
          this.maritalTypeFormatted = "Comunhão Universal de Bens";
        } else if (newValue === "Separação total") {
          this.maritalTypeFormatted = "Separação Total de Bens";
        } else if (newValue === "Final nos aquestos") {
          this.maritalTypeFormatted = "Participação Final nos Aquestos";
        } else {
          this.maritalTypeFormatted = newValue;
        }
      },
      immediate: true,
    },
    maritalTypeFormatted(newValue) {
      this.user.marital_type = newValue;
    },
  },

  methods: {
    ...mapMutations("sales", ["setUser"]),
    ...mapActions("sales", ["getMember"]),

    getInitialUser() {
      return {
        id: "",
        customer_id: "",
        company: "juntos",
        buyer_id: "",
        name: "",
        email: "",
        cpf: "",
        date_of_birth: "",
        group: "",
        ID_document: "",
        last_invoice: "",
        nationality: "",
        payment_type: "",
        phone: "",
        profession: "",
        requiredPSChange: 0,
        address: {
          address: "",
          address_number: "",
          address_complement: "",
          district: "",
          postal_code: "",
          state: null,
          city: "",
          country: {
            initials: "BR",
            name: "Brasil",
          },
        },
        status: "ATIVO",
        gender: "",
        person_type: "",
        average_consumption: 0,
      };
    },

    setUserData(userData = {}) {
      const initialUserData = this.getInitialUser();
      return {
        ...initialUserData,
        ...userData,
        address: {
          ...initialUserData.address,
          ...(userData.address || {}),
          country: {
            ...initialUserData.address.country,
            ...(userData.address?.country || {}),
          },
        },
      };
    },

    showDocumentModal(customer) {
      this.$refs.documentModal.showDocumentModal(customer);
    },

    openQualification() {
      eventBus.$emit("qualification", true);
    },

    async createUser() {
      this.loadingCreateUser = true;
      if (this.$refs.form.validate()) {
        if (this.user.person_type === "pf") {
          let complementary_data = await getComplementaryData(this.user.cpf);
          this.user = {
            ...this.user,
            ...complementary_data,
            last_agent_email: this.loggedUser.email,
            last_agent_id: this.loggedUser.id,
            last_agent_name: this.loggedUser.name,
            signedcontract_partner: this.loggedUser.email,
          };
        }
        storeCustomer(this.user)
          .then(async (user) => {
            if (user.status === 200 && user.data.id) {
              this.mode = "edit";
              this.user = user.data;
              this.show_snack("Usuário criado com sucesso.", "green");
              this.loadingCreateUser = false;
            } else {
              this.loadingCreateUser = false;
              console.error("user", user);
              this.show_snack("Erro ao cadastrar membro.", "red");
            }
          })
          .catch((error) => {
            console.error("Erro ao realizar venda!", error);
            let err_msg = "Erro ao gravar membro! Contate nosso suporte.";
            if (error.code === "auth/email-already-in-use") {
              err_msg = "Este email está sendo utilizado por outra conta.";
            }
            this.show_snack(err_msg, "red");
            this.loadingCreateUser = false;
          });
      } else {
        this.loadingCreateUser = false;
        this.show_snack("Preencha todos os campos obrigatórios.", "red");
      }
    },

    async updateUserFunction() {
      if (this.$refs.form.validate()) {
        this.loadingUpdateUser = true;
        this.user = {
          ...this.user,
          last_agent_email: this.loggedUser.email,
          last_agent_id: this.loggedUser.id,
          last_agent_name: this.loggedUser.name,
          updated_at: new Date(),
        };
        await updateUser(this.user.customer_id, this.user)
          .then(() => {
            this.loadingUpdateUser = false;
            this.show_snack("Usuário atualizado com sucesso.", "green");
          })
          .catch((error) => {
            this.loadingUpdateUser = false;
            console.error("error", error);
            this.show_snack("Erro ao atualizar usuário.", "red");
          });
      }
    },

    show_snack(message, color) {
      this.snack.color = color;
      this.snack.snackMessage = message;
      this.snack.snackbar = true;
    },

    goToCustomerCare() {
      this.$router.push({ path: "/atendimento/?email=" + this.user.email });
    },

    validaCPF(cpf) {
      return validaCPF(cpf);
    },

    validaCNPJ(cnpj) {
      return validaCNPJ(cnpj);
    },

    buscaCep(cep) {
      if (cep && cep !== "") {
        this.loading_cep = true;
        getCEP(cep)
          .then((result) => {
            this.user.address.address = result.data.logradouro;
            this.user.address.district = result.data.bairro;
            this.user.address.city = result.data.localidade;
            this.user.address.address_complement = null;
            this.user.address.address_number = null;
            this.user.address.state = this.states.find(
              (item) => item.initials === result.data.uf,
            );
            this.loading_cep = false;
          })
          .catch((error) => {
            console.error(error);
            this.loading_cep = false;
          });
      }
    },

    async buscaMember(param, type) {
      if (!param) return;
      if (type === "email") param.toLowerCase();
      this.loadingDialog = true;
      this.$store.commit("qualification/setQualifications", []);
      let member = await this.getMember({ value: param, type });
      if (member) {
        this.user = JSON.parse(JSON.stringify(member));
        if (/@/.test(member?.id)) {
          this.mode = "new";
        } else {
          this.setUser(member);
          this.mode = "edit";
          this.$emit("updateUcList", member);
        }
      } else {
        if (type === "email") this.$emit("updateUcList");
      }
      this.loadingDialog = false;
    },
  },
};
</script>

<style lang="scss">
#core-view
  > div
  > div
  > div.flex.pt-0.xs12.md12
  > div
  > div.pt-0.v-card.v-sheet.theme--light
  > div.v-card__text
  > form
  > div
  > div
  > div:nth-child(5)
  > div
  > div.v-input__append-outer
  > div
  > i {
  cursor: pointer;
}
</style>
